import { ButtonCombinedProps } from './types';

const usePresenter = (props: ButtonCombinedProps): ButtonCombinedProps => {
  return props;
};

export default usePresenter;
